import React,{useState,useEffect} from 'react'
import './Chat.css'
import {useParams} from "react-router-dom"
import StarBorderOutlinedIcon from "@material-ui/icons/StarBorderOutlined"
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined"
import db from '../Firebase'
import Message from './Message'
import ChatInput from './ChatInput'

function Chat() {
    const { roomId} = useParams();
    const [roomDetail,setroomDetail] = useState(null)
    const [roomMessages,setroomMessages] = useState([])

    useEffect(() => {
        if(roomId){
            db.collection('rooms').doc(roomId)
            .onSnapshot((snapshot) => setroomDetail(
                snapshot.data()
            ) )
        }
        db.collection('rooms').doc(roomId)
        .collection('messages').orderBy('time','asc')
        .onSnapshot((snapshot) => setroomMessages(
            snapshot.docs.map((doc) => doc.data())
        ))
        
    },[roomId])
    return (
        <div className="chat">
            <div className="chat__header" >
                <div className="chat__headerLeft" >
                    <h4 className="chat__channelName" >
                        <strong >
                              # {roomDetail?.name}
                        </strong>
                        <StarBorderOutlinedIcon />                       
                    </h4>
                </div>
                <div className="chat__headerRight" >               
                       <p> <InfoOutlinedIcon />  Details </p>  
                </div>
            </div>
            <div className="chat__messages">
                    {roomMessages.map(({message,time,user,userImage}) => <Message message={message} time={time} user={user} userImage={userImage} /> )}
            </div>
            <div>
                <ChatInput channelName={roomDetail?.name} channelId={roomId}/>
            </div>
        </div>
    )
}

export default Chat
